import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/close_btn.png'


const _hoisted_1 = { class: "popup" }
const _hoisted_2 = { class: "file-upload-popup" }
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = { class: "popup-body" }
const _hoisted_5 = { class: "popup-footer" }

import { ref, onMounted } from "vue";
import anncounceAPI from "../../api/announceAPI";
import codeAPI from "@/api/codeAPI";

interface Param {
  // 첨부파일명: string;
  // 첨부파일처리: string;
  회원구분: string | null;
  파일제목: string | null;
  자료식별값2: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FileRequestPop',
  props: {
    공고순번: {},
    수주수행구분: {}
  },
  emits: ["closePopup"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// HTMLInputElement 타입을 명시적으로 지정
const fileInp = ref<HTMLInputElement | null>(null);
const 파일제목 = ref<string>("");

// Param 인터페이스 정의하여 param 타입 지정
const param = ref<Param>({
  // 첨부파일명: "",
  // 첨부파일처리: "",
  회원구분: "",
  파일제목: "",
  자료식별값2: "",
});
const 구분목록 = ref<{ id: string; text: string }[]>([]);
onMounted(async() => {
  await codeAPI.getSelectedCode('0002').then((res) => {
    구분목록.value = res.data.data.map((item: any) => { 
      return {id:item.코드,text:item.코드명}
    });
  });
})
const requestFile = () => {
  console.log(isNaN(Number(파일제목.value)))
  if (!파일제목.value) {
    alert("파일 제목을 입력해주세요.");
    return;
  }

  param.value.회원구분 = props.수주수행구분;
  param.value.파일제목 = 파일제목.value;
  param.value.자료식별값2 = props.수주수행구분;

  if (props.공고순번 === null) {
    alert("공고순번이 null입니다. 파일요청을 진행할 수 없습니다.");
    return;
  }
  anncounceAPI
    .repuestAnnounceFile(props.공고순번, param.value)
    .then((res) => {
      if (res.data.success) {
        alert("등록이 완료되었습니다.");
        closePopup(true);
      }
    })
    .catch((error) => {
      console.error("파일 업로드 중 오류 발생:", error);
    });
};

function closePopup(refresh: boolean) {
  emit("closePopup", { popupType: "fileRequest", refresh });
}

return (_ctx: any,_cache: any) => {
  const _component_Select2 = _resolveComponent("Select2")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "popup_cover" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "popup_title" }, "파일 요청", -1)),
        _createElementVNode("img", {
          src: _imports_0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (closePopup(false))),
          class: "close_icon"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "popup_desc" }, "필요한 파일명을 선택 또는 입력하세요.", -1)),
        _createVNode(_component_Select2, {
          modelValue: 파일제목.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((파일제목).value = $event)),
          options: 구분목록.value,
          settings: {height:'24px',width:'100%',tags:true}
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "popup_close_btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (closePopup(false)))
        }, "취소"),
        _createElementVNode("div", {
          class: "popup_confirm_btn",
          onClick: requestFile
        }, "등록")
      ])
    ])
  ]))
}
}

})